























































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositInstantAccessSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositInstantAccessSettingsRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'AccountDepositInstantAccessSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountDepositInstantAccessSettingsRequest = new UpdateAccountDepositInstantAccessSettingsRequest(DepositAccountSettingsModule.settings.depositInstantAccessSettings, new Date(), this.defaultWalletCurrency);
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositInstantAccessSettingsRequest(DepositAccountSettingsModule.settings.depositInstantAccessSettings, new Date(), this.defaultWalletCurrency);
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositInstantAccessSettings;
    }

    get defaultWalletCurrency () {
        return DepositAccountSettingsModule.productIssue.generalSettings.defaultWalletCurrency;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get fundingWindowTriggerTypeOptions() {
        return ListUtils.fundingWindowTriggerTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
           return;
        }
        else {
            this.dialog = false;
            this.request.fundingWindowPeriodValue = +this.request.fundingWindowPeriodValue;
            this.request.initialDepositWindowPeriodValue = +this.request.initialDepositWindowPeriodValue;
            await DepositAccountSettingsModule.editDepositInstantAccessSettings(this.request);
        }
    }

}
